import React from 'react';

import classnames from 'clsx';

import CheckIcon from '@mui/icons-material/Check';

function Checkbox({ labelText, checked, onToggle, wrapperClassName = '', buttonClassName }) {
  return (
    <div className={classnames('le-checkbox-container', wrapperClassName)}>
      <button
        className={classnames('le-checkbox', buttonClassName)}
        role="checkbox"
        aria-checked={checked.toString()}
        onClick={onToggle}
      >
        {checked && <CheckIcon className="tick-icon" fontSize="small" />}
      </button>
      <div className="le-checkbox-label" onClick={onToggle}>
        {labelText}
      </div>
    </div>
  );
}

export default Checkbox;
